import Vue from 'vue'
import VueGtag from 'vue-gtag'
import { ANALYTICS_KEY } from './env'

/** GA4 (G-…) or legacy UA (UA-…). Skip placeholder / empty keys. */
export function isAnalyticsConfigured (key) {
  if (!key || key === 'secretKey') {
    return false
  }
  return /^(G-[A-Z0-9]+|UA-\d+-\d+)$/.test(key)
}

/**
 * SPA page views via vue-gtag + vue-router (GA4 page_view on each navigation).
 * Only loads in production builds with a real measurement ID.
 */
export function installAnalytics (router) {
  if (!isAnalyticsConfigured(ANALYTICS_KEY)) {
    return
  }
  if (process.env.NODE_ENV !== 'production') {
    return
  }

  Vue.use(VueGtag, {
    config: { id: ANALYTICS_KEY },
    pageTrackerScreenviewEnabled: true
  }, router)
}
